<ion-app>
  <ion-content>
    <ion-router-outlet></ion-router-outlet>
  </ion-content>
</ion-app>
